import React from 'react';

const Tools = ({ data }) => {
  const { tools } = data[0]
  return (
    <div className="my-5" id="tools">
      <div className="container">
        <h1 className="title__focus my-3">Tools</h1>
        <ul className="tool__group row">
          {
            tools.map(tool => (
              <li className="col-md-4 tool__item my-3">
                <div className="card">
                  <div className="card-header">
                    <h3>{tool.titleTool}</h3>
                    <img src={tool.imgTool} alt={tool.titleTool} />

                  </div>
                  <div className="card-body">
                    {tool.descriptionTool}
                  </div>
                </div>
              </li>
            ))
          }
        </ul>
      </div>
    </div>
  );
}

export default Tools;
